import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { i18nReducer } from 'react-redux-i18n';

// Custom Reducers.
import reportBloodPressure from 'reducers/reportBloodPressure';

const appReducer = combineReducers({
  router: routerReducer,
  i18n: i18nReducer,
  reportBloodPressure,
});

const rootReducer = (state, action) => appReducer(state, action);

export default rootReducer;
